export const GET_SELLER_INPUT = "GET_SELLER_INPUT";
export const GET_UPDATE_INPUT = "GET_UPDATE_INPUT";
export const SET_SELLER_INPUT = "SET_SELLER_INPUT";
export const AFTER_CREATE_SELLER = "AFTER_CREATE_SELLER";
export const IS_CREATE_SELLER = "IS_CREATE_SELLER";
export const IS_UPDATE_SELLER = "IS_UPDATE_SELLER";
export const IS_UPDATED_SELLER = "IS_UPDATED_SELLER";
export const SELLER_LIST = "SELLER_LIST";
export const SELLER_LIST_META = "SELLER_LIST_META";
export const IS_SELLER_LIST_LOADING = "IS_SELLER_LIST_LOADING";
export const IS_SELLER_STATUS_UPDATING = "IS_SELLER_STATUS_UPDATING";
export const AFTER_DELETED = "AFTER_DELETED";
export const IS_IMG_LOADING = "IS_IMG_LOADING";
